var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8h18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8v11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8v11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19h18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8V5h8v3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5h6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12h7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16h7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8v11"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13h1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesk);
export default __webpack_public_path__ + "static/media/desk.d81e28038a608bef22a88647e6423322.svg";
export { ForwardRef as ReactComponent };